module.exports = __webpack_public_path__ + "static/img/fish1.1396be6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish1.png
// module id = WPGz
// module chunks = 0